import type { HelpFile } from '../../types/help'
import { HelpToggleButtonTestIds } from '../../../testids/HelpToggleButtonTestIds'

export const helpToggleButtonHelp: HelpFile = {
  docPage: '/docs/help-system/overview',
  texts: {
    [HelpToggleButtonTestIds.btnHelpToggle]: null,
  },
}
